// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3vTYx","image":"Header_image__2WN94","name":"Header_name__1IV4q","info":"Header_info__2vOvf","infoRow":"Header_infoRow__3TY0U"};